import { error, redirect } from "@sveltejs/kit";

import redirects from "./redirects.toml";

/** Handle a missing page, possibly redirecting using `redirects.yaml`. */
export function redirectOr404(name: string): never {
  const newName = redirects[name];
  if (newName) {
    redirect(308, `/docs/${newName}`);
  } else {
    error(404);
  }
}
